import type { DocumentEditorCmp_CustomLayout } from '../fragments/custom-layout.fragment';

import { removeNullsFromCustomLayout } from './remove-nulls-from-custom-layout.util';

export const customLayoutsPriority = (
  primaryCustomLayouts: readonly DocumentEditorCmp_CustomLayout[],
  secondaryCustomLayouts: readonly DocumentEditorCmp_CustomLayout[],
) => [
  ...primaryCustomLayouts.map((pcl) => {
    const scl = secondaryCustomLayouts.find(
      (s) => s.sectionId === pcl.sectionId,
    );
    if (scl) {
      return {
        ...removeNullsFromCustomLayout(scl),
        ...removeNullsFromCustomLayout(pcl),
      };
    }
    return { ...removeNullsFromCustomLayout(pcl) };
  }),
  ...secondaryCustomLayouts
    .filter(
      (scl) =>
        !primaryCustomLayouts.find((pcl) => pcl.sectionId === scl.sectionId),
    )
    .map(removeNullsFromCustomLayout),
];
